import { commonWebSocket } from '@services/common/common.constants';
import { ILogEntry } from '@app-types/websocket/log.types';
import { createReducer } from 'redux-act';

const defaultState = {
  logEntries: []
};

const reducer = createReducer<typeof defaultState>({}, defaultState);

reducer
  .on(commonWebSocket.special.LOG_ENTRIES, (state:any, payload:any) => {
    if (!Array.isArray(payload?.logEntries)) {
      return state;
    }

    const previousEntries:ILogEntry[] = Array.isArray(state.logEntries) ? state.logEntries : [];
    const logEntries = payload.logEntries
      .filter((entry: any) => entry !== undefined && entry !== null)
      .concat(previousEntries);

    return {
      ...state,
      logEntries
    };
  });

export default reducer;



// WEBPACK FOOTER //
// ./src/services/log/log.reducer.ts